import {useTranslation} from 'react-i18next';
import {statisticsQuery} from '@store/statistics';
import {useObservable} from '@ngneat/react-rxjs';
import {Colors} from '@constants/colors.constants';
import {CircularProgress, Stack, Typography} from '@mui/material';
import React from 'react';
import SmallStatisticsCard from '@components/statistics/cards/SmallStatistics.card';
import {NumberExt} from '@utils/extensions/number.extension';

const ValoTurnoverChargesCard = () => {
  const {t} = useTranslation();

  const [{turnoverChargesValo, loading}] = useObservable(statisticsQuery.turnoverChargesValo$);

  const margin = ((turnoverChargesValo?.charges || 0) - (turnoverChargesValo?.turnover || 0)) * 100 / (turnoverChargesValo?.turnover || 1);

  return (
    <Stack flex={1} height="360px" bgcolor={Colors.white} borderRadius="4px" p="20px">
      <Typography fontSize={18} fontWeight="700" mb="20px">
        {t('dashboard.statistics.finance.turnoverChargesValo.title')}
      </Typography>

      {loading && <CircularProgress size={30}/>}
      {!loading && <Stack flex={1} width="100%" spacing={2}>
          <Stack flex={1}>
              <SmallStatisticsCard
                  description={t('dashboard.statistics.finance.turnoverChargesValo.turnover')}
                  value={turnoverChargesValo?.charges ? NumberExt.toCurrency(turnoverChargesValo.charges / 100 * -1) : '-'}
              />
          </Stack>
          <Stack flex={1}>
              <SmallStatisticsCard
                  description={t('dashboard.statistics.finance.turnoverChargesValo.charges')}
                  value={turnoverChargesValo?.turnover ? NumberExt.toCurrency(turnoverChargesValo.turnover / 100 * -1) : '-'}
              />
          </Stack>
          <Stack flex={1}>
              <SmallStatisticsCard
                  description={t('dashboard.statistics.finance.turnoverChargesValo.margin')}
                  value={`${margin.toFixed(2)}%`}
              />
          </Stack>
      </Stack>}
    </Stack>
  );
};

export default ValoTurnoverChargesCard;
